import { useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { usePurchaseDataContext } from 'src/contexts/PurchaseDataContext';
import { useSearchDataContext } from 'src/contexts/SearchDataContext';
import { isInSearchV2Page } from 'src/utils/deepLinkUtils';

/**
 * Hook that provides a single method to trigger delayed refetch for all
 * OpenSearch-backed V2 search views (listings, sales, purchases).
 *
 * Only triggers refetch when the user is on a V2 search page.
 */
export function useSearchV2DataRefetch() {
  const { mainRoute } = useAppContext();
  const { delayedRefetch: searchDelayedRefetch } = useSearchDataContext();
  const { delayedRefetch: purchaseDelayedRefetch } = usePurchaseDataContext();

  const searchV2DataDelayedRefetch = useCallback(async () => {
    if (!isInSearchV2Page(mainRoute)) {
      return;
    }
    await Promise.all([searchDelayedRefetch(), purchaseDelayedRefetch()]);
  }, [mainRoute, searchDelayedRefetch, purchaseDelayedRefetch]);

  return { searchV2DataDelayedRefetch };
}
